module.exports = __webpack_public_path__ + "img/tubiao2_334_335.7b05d53d.png";